import { queryOptions } from "@tanstack/react-query";
import { LST_FAV } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import type { LikeListResponse } from "~/types/like";

/**
 * 自分から（自分が送った）いいね一覧 — lst_fav。
 * いいね一覧画面と、さがす（coco+ のおすすめ枠からいいね済みの子を外す）で使う
 */
export const sentLikeListQueryOptions = queryOptions({
  queryKey: queryKeys.like.sent(),
  queryFn: () => apiClient<LikeListResponse>(LST_FAV),
});
